import { render, staticRenderFns } from "./CharacterCreatePage.vue?vue&type=template&id=a5f89172&scoped=true&"
import script from "./CharacterCreatePage.vue?vue&type=script&lang=ts&"
export * from "./CharacterCreatePage.vue?vue&type=script&lang=ts&"
import style0 from "./CharacterCreatePage.vue?vue&type=style&index=0&id=a5f89172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f89172",
  null
  
)

export default component.exports